<template>
  <div class="home">
    <SearchbarDesktop class="hidden-xs-only" />
    <SearchbarMobile class="hidden-sm-and-up" />
    <v-row class="d-flex align-center justify-center">
      <v-col cols="12" sm="6" lg="3">
        <div class="ma-2">
          <h1 class="white--text">
            PvP Meta
            <v-icon large dark>mdi-sword</v-icon>
          </h1>
          <span
            class="white--text"
          >Find out what the most popular classes are in the Red Battlefield!</span>
          <v-spacer></v-spacer>
          <v-btn>All classes</v-btn>
        </div>
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <ClassCard bdoClass="guardian" usagePercentage="10" />
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <ClassCard bdoClass="lahn" usagePercentage="7" />
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <ClassCard bdoClass="hashashin" usagePercentage="5" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="4">
        <SparklineCard />
      </v-col>
      <v-col cols="12" lg="4">
        <SparklineCard />
      </v-col>
      <v-col cols="12" lg="4">
        <SparklineCard />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SparklineCard from "@/components/SparklineCard.vue";
import ClassCard from "@/components/ClassCard.vue";
import SearchbarDesktop from "@/components/SearchbarDesktop.vue";
import SearchbarMobile from "@/components/SearchbarMobile.vue";

export default {
  name: "Home",

  components: {
    SparklineCard,
    ClassCard,
    SearchbarDesktop,
    SearchbarMobile
  }
};
</script>

<style scoped>
</style>
